J = jQuery.noConflict();

        const unitTypes = {
            0: '%',
            1: 'g/lb',
            2: 'mg/kg',
            3: 'mg/lb',
            4: 'mg/oz',
            5: 'ppm'
        }

        const multiplicationFactor = {
            '01': 4.54,
            '02': 10000,
            '03': 4540,
            '04': 284.625,
            '05': 10000,
            '10': 0.2203,
            '12': 2205,
            '13': 1000,
            '14': 62.5,
            '15': 2205,
            '20': 0.0001,
            '21': 0.000454,
            '23': 0.454,
            '24': 0.028375,
            '25': 1,
            '30': 0.0002203,
            '31': 0.001,
            '32': 2.205,
            '34': 0.0625,
            '35': 2.205,
            '40': 0.00352,
            '41': 0.016,
            '42': 35.2,
            '43': 16,
            '45': 35.2,
            '50': 0.0001,
            '51': 0.000454,
            '52': 1,
            '53': 0.454,
            '54': 0.028375
        }

        var oldQuantityValue = 0;

        J(function() {
            J('#form-unit-conversion').submit(function(e) {
               e.preventDefault();
            });

            J('#text-quantity').keyup(function() {
                this.value = this.value.replace(/[^0-9.]/g,'');

                var decimalCount = 0;
                for (var i = 0; i < this.value.length; i++) {
                    if (this.value.charAt(i) === '.') {
                        decimalCount++;
                    }

                    if (decimalCount > 1) {
                        this.value = this.value.substr(0, this.value.length - 1);
                    }
                }

                if (this.value === '' || this.value === '.') {
                    J('#result-conversion-tool').empty();
                } else if (this.value !== oldQuantityValue) {
                    J(this).change();
                }
            });

            J('#text-quantity').focus(function() {
                oldQuantityValue = this.value;
            })

            J('#select-units').change(function () {
                var selectedUnit = J(this).find('option:selected').text();
                var options = '<option/>';

                J.each(unitTypes, function(k, v) {
                    if (v !== selectedUnit) {
                        options += '<option value="' + k + '">' + v + '</option>';
                    }
                });

                J('#select-conversion-units').html(options);
            });

            J('#text-quantity').change(function() {
                var quantityUnitsElement = J('#select-units');
                var conversionUnitElement = J('#select-conversion-units');

                if (this.value !== '' && quantityUnitsElement.val() !== '' && conversionUnitElement !== '') {
                    updateResults(J(this), quantityUnitsElement, conversionUnitElement);
                }
            })

            J('#select-units').change(function() {
                J('#result-conversion-tool').empty();
            })

            J('#select-conversion-units').change(function() {
                var quantityElement = J('#text-quantity');
                var quantityUnitsElement = J('#select-units');

                if (this.value !== '' && quantityElement.val() !== '' && quantityUnitsElement !== '') {
                    updateResults(quantityElement, quantityUnitsElement, J(this));
                }
            });
        });

        function updateResults(quantityElement, quantityUnitsElement, conversionUnitsElement) {
            var key = "" + quantityUnitsElement.val() + conversionUnitsElement.val();
            var result = parseFloat((quantityElement.val() * multiplicationFactor[key]).toFixed(4)).toString();
            var resultUnit = " " + conversionUnitsElement.find('option:selected').text();
            var resultArray = result.split('.');
            var wholeNumbers = resultArray[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

            result = wholeNumbers + (resultArray.length > 1 ? "." + resultArray[1] : '');

            if (resultArray[1] === '0000') {
                result = result.substr(0, result.indexOf('.'));
            }

            J('#result-conversion-tool').html(result + resultUnit);
        }